import translate from '@translate';
import React, { FC } from 'react';
import { GridItem } from 'src/components/Grid';
import { OrderType } from 'src/types/order';
import ZasilkovnaSelect from 'src/components/ZasilkovnaSelect';
import ZasilkovnaExternalSelect from 'src/components/ZasilkovnaExternalSelect';
import BalikovnaSelect from 'src/components/BalikovnaSelect';
import DdpSelect from 'src/components/DdpSelect';
import PplPlacesSelect from 'src/components/PplPlacesSelect';
import DhlServicePointSelect from 'src/components/DhlServicePointSelect';
import GlsSkPlacesSelect from '../../components/GlsSkPlacesSelect';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';
import { isDhlD2svpServiceCode } from 'skladon-utils';
export interface AddressIdSelectPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: OrderType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    summary?: boolean;
}

const AddressIdSelect: FC<AddressIdSelectPropsType> = (props) => {
    switch (props.editData.SHIPPER) {
        case 'zasilkovna':
            return (
                <GridItem cols={12}>
                    <ZasilkovnaSelect
                        value={props.editData.ADDRESS_ID}
                        error={props.editErrors.ADDRESS_ID}
                        onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                        name="ADDRESS_ID"
                        label={translate('orderDetail.dispensingPoint')}
                        required
                        fullWidth
                        disabled={props.disableEdit || props.summary}
                    />
                </GridItem>
            );
        case 'PCKT_EXTERNAL':
            return (
                <GridItem cols={12}>
                    <ZasilkovnaExternalSelect
                        value={props.editData.ADDRESS_ID}
                        serviceCode={props.editData.SHIPPER_SERVICE_CODE}
                        error={props.editErrors.ADDRESS_ID}
                        onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                        name="ADDRESS_ID"
                        label={translate('orderDetail.dispensingPoint')}
                        // required
                        fullWidth
                        disabled={props.disableEdit || props.summary}
                    />
                </GridItem>
            );
        case 'CP':
            if (props.editData.SHIPPER_SERVICE_CODE?.indexOf('CPNB') === 0) {
                return (
                    <GridItem cols={12}>
                        <BalikovnaSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            name="ADDRESS_ID"
                            label={translate('orderDetail.dispensingPoint')}
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                        />
                    </GridItem>
                );
            }
            return null;
        case 'PPL':
            if (['PPLPP', 'PPLBOX'].includes(props.editData.SHIPPER_SERVICE_CODE || '')) {
                return (
                    <GridItem cols={12}>
                        <PplPlacesSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            onRecipientStateChange={(value, error) =>
                                props.onChange('RECIPIENT_STATE', value, error)
                            }
                            name="ADDRESS_ID"
                            label={translate('orderDetail.dispensingPoint')}
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                            recipientState={
                                props.editData.SHIPPER_SERVICE_CODE === 'PPLBOX'
                                    ? 'CZ'
                                    : props.editData.RECIPIENT_STATE
                            }
                            pointType={
                                props.editData.SHIPPER_SERVICE_CODE === 'PPLBOX' ? 'ParcelBox' : undefined
                            }
                        />
                    </GridItem>
                );
            }
            return null;
        case 'GLS':
            if (['GLSPS'].includes(props.editData.SHIPPER_SERVICE_CODE || '')) {
                return (
                    <GridItem cols={12}>
                        <GlsSkPlacesSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            name="ADDRESS_ID"
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                            serviceCode={props.editData.SHIPPER_SERVICE_CODE}
                        />
                    </GridItem>
                );
            }
            return null;
        case 'GLSSK':
            if (['GLSSKPS'].includes(props.editData.SHIPPER_SERVICE_CODE || '')) {
                return (
                    <GridItem cols={12}>
                        <GlsSkPlacesSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            name="ADDRESS_ID"
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                            serviceCode={props.editData.SHIPPER_SERVICE_CODE}
                        />
                    </GridItem>
                );
            }
            return null;
        case 'DHL':
            if (isDhlD2svpServiceCode(props.editData.SHIPPER_SERVICE_CODE)) {
                return (
                    <GridItem cols={12}>
                        <DhlServicePointSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            name="ADDRESS_ID"
                            label={translate('orderDetail.dispensingPoint')}
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                            recipientState={props.editData.RECIPIENT_STATE}
                        />
                    </GridItem>
                );
            }
            return null;
        default:
            if (props.editData.SHIPPER_SERVICE_CODE === 'DPDPS') {
                return (
                    <GridItem cols={12}>
                        <DdpSelect
                            value={props.editData.ADDRESS_ID}
                            error={props.editErrors.ADDRESS_ID}
                            onChange={(value, error) => props.onChange('ADDRESS_ID', value, error)}
                            name="ADDRESS_ID"
                            label={translate('orderDetail.dispensingPoint')}
                            required
                            fullWidth
                            disabled={props.disableEdit || props.summary}
                        />
                    </GridItem>
                );
            }
            return null;
    }
};

export default AddressIdSelect;
